import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';

import FilterableOptionCards from 'components/common/OptionCards/FilterableOptionCards';
import CheckboxGroup from 'components/InputsField/formikInputs/CheckboxGroup';
import FormikCheckboxField from 'components/InputsField/formikInputs/FormikCheckboxField';
import FormikTextField from 'components/InputsField/formikInputs/FormikTextField';
import { FormikTextareaField } from 'components/InputsField/formikInputs/FormikTextareaField';
import { TRANSPORT_BODYTYPE_ADDITIONALS } from 'constants/transport';

import { useTransportDictionaries, toSelectedArray } from '../dictionaries';
import styles from './styles.module.scss';

const FIELD = 'transports_loading_types';

const ExtraStep = () => {
  const { t } = useTranslation();
  const { loadingTypes } = useTransportDictionaries();
  const { values, setFieldValue, setFieldTouched } = useFormikContext<any>();

  const selected = toSelectedArray(values[FIELD]);

  const handleToggle = (value: string | number) => {
    const next = selected.some((item) => String(item) === String(value))
      ? selected.filter((item) => String(item) !== String(value))
      : [...selected, value];
    setFieldValue(FIELD, next);
    setFieldTouched(FIELD, true, false);
  };

  const isCoupling =
    String(values.transport_bodytype_additionals_id) === TRANSPORT_BODYTYPE_ADDITIONALS.COUPLING;

  return (
    <div className={styles.step}>
      <div className={styles.group}>
        <p className={styles.groupTitle}>{t('transportFields.body_section.uploading')}</p>
        <FilterableOptionCards
          options={loadingTypes}
          columns={3}
          value={selected}
          onChange={handleToggle}
        />
      </div>

      <div className={styles.group}>
        <p className={styles.groupTitle}>{t('transportFields.steps.equipment')}</p>
        <div className={styles.checkboxes}>
          <CheckboxGroup
            checkboxes={[
              <FormikCheckboxField
                name="conics"
                id="conics"
                label={t('transportFields.body_section.bolsters')}
              />,
              <FormikCheckboxField
                name="gidrolift"
                id="gidrolift"
                label={t('transportFields.body_section.tailLift')}
              />,
              <FormikCheckboxField
                name="satellite_monitoring"
                id="satellite_monitoring"
                label={t('transportFields.body_section.satellite_monitoring')}
              />,
            ]}
          />
        </div>
      </div>

      {isCoupling && (
        <FormikTextField
          name="trailer_registration_number"
          label={t('transportFields.body_section.if_checkbox_3.licence')}
          maxLength="13"
          placeholder="A 007AA 183"
          errorMode="static"
        />
      )}

      <div className={styles.notes}>
        <FormikTextareaField
          name="notes"
          label={t('addContact.notes')}
          rows="5"
          maxLength={4096}
          placeholder={t('addContact.notes_grey')}
        />
      </div>
    </div>
  );
};

export default ExtraStep;
